<style>
  .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    display: grid;
    grid-template-columns: 75px auto 75px; /* default */
    color: #ccc;
    font-size: 21px;
    font-weight: bold;
    height: 42px;
    box-shadow: 0 2px 5px rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 100;
  }
  .white {
    background-color: rgba(255, 255, 255, 0.8);
    color: black;
    box-shadow: 0 2px 5px rgb(0, 0, 0, 0.2);
  }
  .back {
    grid-column: 1;
    padding: 9px 0 0 14px;
  }
  .title {
    grid-column: 2;
    padding-top: 8px;
    text-align: center;
  }
  .buttons {
    grid-column: 3;
    padding-top: 9px;
    text-align: right;
  }

  .margin {
    /* padding: 0 15px 0 0; */
    display: inline-block;
    width: 35px;
    text-align: center;
  }
  i {
    font-size: 24px;
  }
  /* .icon-date_range{
  font-size: 28px;
} */
</style>

<div
  class="header {white == true ? 'white' : ''}"
  style="grid-template-columns: {space}px auto {space}px;"
>
  {#if back}
  <div class="back" on:click="{ () => { dispatch('back') } }">
    <i class="icon-arrow_back_ios"></i>
  </div>
  {:else if leftIcon}
  <div class="back" on:click="{ () => { dispatch(leftIcon.callback) } }">
    <i class="{leftIcon.icon}"></i>
  </div>

  {:else}
  <div class="back"></div>
  {/if}
  <div class="title"><slot></slot></div>
  <div class="buttons">
    {#each buttons as item}
    <span class="margin" on:click="{ () => dispatch(item.callback) }"
      ><i class="{item.icon}"></i
    ></span>
    {/each}
  </div>
</div>

<script>
  import { push, pop, replace, location } from "svelte-spa-router";

  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  export let back = false;
  export let white = false;
  // export let buttons = [ {icon: "icon-calendar_add", text: "Add Event", callback: "addEvent", disabled: false, }, {icon: "icon-equalizer", text: "Filter Events", callback: "filterEvents", disabled: false, }, ];
  export let buttons = [];
  export let leftIcon = "";

  let space = 0;

  $: {
    if (buttons) calc();
  }

  function calc() {
    space = (buttons.length || 1) * 35; // pixels
  }
</script>
